module.exports = __webpack_public_path__ + "static/media/people-group.231cfae3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/people-group.svg
// module id = 269
// module chunks = 3